module.exports = __webpack_public_path__ + "img/744.4b596566.jpg";